// extracted by mini-css-extract-plugin
module.exports = {"flashItem":"styles_flashItem__SFnbT","flashItem__link":"styles_flashItem__link__bchEz","flashItem__linkDismissable":"styles_flashItem__linkDismissable__bu7wb"};